/**
 * Server-side requests to www.cph.dk must identify as CPH's mobile app.
 *
 * CPH fronts www.cph.dk with Akamai, which refuses datacenter egress: every
 * fetch from Vercel gets 403 Access Denied. The refusal is scored on the
 * User-Agent as well as the source IP, and the app's own User-Agents are
 * allowed through from anywhere, since phones dial in from carrier NAT and
 * every other network. Measured from a datacenter host in one minute:
 * app UA 200 with 736 flight rows, curl UA 403, Chrome UA 403.
 *
 * Browsers forbid setting User-Agent and silently drop it, so this only
 * applies on the server. In the browser the request already succeeds: a real
 * visitor has a residential IP and a genuine browser fingerprint, which is
 * the combination Akamai serves.
 *
 * ponytail: a header, not a headless browser. If CPH ever adds app
 * attestation or signed requests this stops working, and the client-side
 * fetch in pages/departures.js and pages/arrivals.js is the fallback that
 * keeps the boards alive.
 */
const CPH_APP_USER_AGENT = 'CPH Airport/4.0.1 (iPhone; iOS 26.2.1; Scale/3.00)';

export const cphHeaders = (extra = {}) =>
    typeof window === 'undefined'
        ? { 'User-Agent': CPH_APP_USER_AGENT, ...extra }
        : { ...extra };
